// extracted by mini-css-extract-plugin
export default {"correct":"Letter_correct__eMoUp","present":"Letter_present__TfDYT","absent":"Letter_absent__GyZtR","empty":"Letter_empty__ly5k3","edit":"Letter_edit__FRHOT"};